import { QuestionPlanDiscountConnection as Question } from "@/components/features/items/edit/plan/_shared/ui/components/connection/discount-connection/discount-connection";

import { usePlanAvailableDiscountIDs } from "./hooks";

export const QuestionPlanDiscountConnection = () => {
	const { availableItemIDs, rawAvailableItemIDs, nameAndIDOptions, onSetAvailableItemIDs } =
		usePlanAvailableDiscountIDs();

	return (
		<Question
			availableItemIDs={availableItemIDs}
			rawAvailableItemIDs={rawAvailableItemIDs}
			nameAndIDOptions={nameAndIDOptions}
			onSetAvailableItemIDs={onSetAvailableItemIDs}
		/>
	);
};

QuestionPlanDiscountConnection.displayName = "QuestionPlanDiscountConnection";
